module.exports = __webpack_public_path__ + "img/fast.33e20fd3.png";